import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Icon from '../helper/Icon';

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center'
  },
  audioSpeedControls: {
    clear: 'both',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  }
};

@Radium
class AudioCardPlayer extends Component {
  constructor(props) {
    super(props);

    this.audioPlayable = false;
    this.audioContainerRef = React.createRef();
    this.audioElementRef = React.createRef();
  }

  state = {
    selectedSpeedIndex: 5,
    availableSpeeds: [
      0.5,
      0.6,
      0.7,
      0.8,
      0.9,
      1.0,
      1.1,
      1.2,
      1.3,
      1.4,
      1.5,
      1.6,
      1.7,
      1.8,
      1.9,
      2.0
    ]
  };

  componentDidMount() {
    const audioElement = this.audioElementRef.current;
    audioElement.src = this.props.url;

    this.audioPlugin = window.audiojs.create(audioElement);

    audioElement.oncanplay = this.canPlay;
  }

  componentDidUpdate(prevProps) {
    if (this.props.url && this.props.url !== prevProps.url) {
      const audioElement = this.audioElementRef.current;
      audioElement.oncanplay = null;

      try {
        audioElement.src = this.props.url;
      } catch (e) {
        console.log(e);
      }

      audioElement.oncanplay = this.canPlay;
    }
  }

  componentWillUnmount() {
    const audioElement = this.audioElementRef.current;
    audioElement.oncanplay = null;
  }

  canPlay = () => {
    if ((this.props.narrationAudio || this.props.autoPlayAudio) && !this.autoPlayed) {
      this.autoPlayed = true;
      try {
        document.querySelector('.audiojs .play') &&
          document.querySelector('.audiojs .play').click();
      } catch (e) {
        console.log(e);
      }
    }
  };

  changeSpeed = () => {
    const speedLength = 16;
    let currentSpeedIndex = this.state.selectedSpeedIndex;

    if (currentSpeedIndex + 1 >= speedLength) {
      currentSpeedIndex = 0;
    } else {
      currentSpeedIndex += 1;
    }

    this.setState({ selectedSpeedIndex: currentSpeedIndex });
    const audioElement = this.audioElementRef.current;
    audioElement.playbackRate = parseFloat(this.state.availableSpeeds[currentSpeedIndex]);
  };

  skipForward = () => {
    const audioElement = this.audioElementRef.current;
    if (this.audioPlayable === true || audioElement.readyState === 4) {
      const d = audioElement.duration;
      const newTime = audioElement.currentTime + 10 <= d ? audioElement.currentTime + 10 : d;
      this.audioPlugin.skipTo(newTime / d);
    }
  };

  skipBack = () => {
    const audioElement = this.audioElementRef.current;
    if (this.audioPlayable === true || audioElement.readyState === 4) {
      const newTime = audioElement.currentTime - 10 >= 0 ? audioElement.currentTime - 10 : 0;
      audioElement.currentTime = newTime;
    }
  };

  render() {
    return (
      <div style={{ ...styles.container, ...this.props.container }}>
        <div className="audioContainer">
          <audio
            controls={true}
            style={{ visibility: 'hidden' }}
            onCanPlay={this.handleCanPlayCallback}
            ref={this.audioElementRef}
          />
        </div>
        {this.props.showControls ? (
          <div style={styles.audioSpeedControls}>
            <div role="button" tabIndex={0} onClick={this.skipBack}>
              <Icon icon="rewind-10" size="1.4em" fill="#000" viewBox="0 0 28 32" />
            </div>
            <div>
              <span role="button" tabIndex={0} onClick={this.changeSpeed}>
                {this.state.availableSpeeds[this.state.selectedSpeedIndex]}X
              </span>
            </div>
            <div role="button" tabIndex={0} onClick={this.skipForward}>
              <Icon icon="forward-10" size="1.4em" fill="#000" viewBox="0 0 28 32" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

AudioCardPlayer.defaultProps = {
  container: {}
};

AudioCardPlayer.propTypes = {
  container: PropTypes.object
};

export default AudioCardPlayer;
